import { useTranslation } from 'react-i18next';

import { TIntegrationSelectOptionsProps } from '@/console/features/integrations/hooks/use-integration-select-options/use-integration-select-options.types';
import { TSelectOption } from '@/shared/components/ui/form/components/searchable-select/base-searchable-select.types';
import { IntegrationFragment } from '@/shared/types/types.generated';

export const useIntegrationSelectOptions = (
  props?: TIntegrationSelectOptionsProps,
) => {
  const { t } = useTranslation();
  const { additionalInfo, disabled } = props || {};

  const isDisabled = (integration: IntegrationFragment) => {
    return disabled?.notYetSupported?.(integration) ?? false;
  };

  const getAdditionalInfo = (integration: IntegrationFragment) => {
    if (disabled?.notYetSupported?.(integration)) {
      return t('common:not_yet_supported');
    }

    const infos = [];
    if (additionalInfo?.integrationType) {
      infos.push(
        t(
          `integration:integration_types.${integration.integrationType.toLowerCase()}`,
        ),
      );
    }
    return infos;
  };

  const createIntegrationOptions = (integration: IntegrationFragment) => {
    return {
      label: integration.name,
      value: {
        name: integration.name,
        integrationId: integration.integrationId,
        objectVersion: integration.objectVersion ?? 0,
      },
      additionalInfo: getAdditionalInfo(integration),
      disabled: isDisabled(integration),
    } as TSelectOption<IntegrationFragment>;
  };

  return { createIntegrationOptions, getAdditionalInfo, isDisabled };
};
